"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.SupportComponent = void 0;
const core_1 = require("@angular/core");
const support_api_service_1 = require("../../../shared/api/support-api.service");
const toast_service_1 = require("../../../ui-components/toast/toast.service");
const enums_1 = require("../@shared-types/support/enums");
let SupportComponent = class SupportComponent {
    constructor(supportApiService, toastService) {
        this.supportApiService = supportApiService;
        this.toastService = toastService;
        this.sending = false;
        this.initTicket = () => {
            this.ticketRequest = {
                content: {
                    description: '',
                    summary: '',
                },
                type: enums_1.ESupportRequestType.SUPPORT,
            };
        };
        this.formSubmission = () => {
            this.sending = true;
            const supportTicketRequest = Object.assign({}, this.ticketRequest);
            this.supportApiService.postSupportTicket(supportTicketRequest)
                .then(() => {
                this.toastService.toast(toast_service_1.ToastType.SUCCESS, 'Supportanfrage gesendet');
                this.initTicket();
                this.sending = false;
            })
                .catch((e) => {
                this.toastService.toast(toast_service_1.ToastType.ERROR, 'Fehler beim Senden der Supportanfrage');
                console.error(e);
                this.sending = false;
            });
        };
        this.ticketRequest = {
            content: {
                description: '',
                summary: '',
            },
            type: enums_1.ESupportRequestType.SUPPORT,
        };
    }
};
SupportComponent = __decorate([
    (0, core_1.Component)({
        templateUrl: require('./support.component.html'),
        selector: 'support',
    }),
    __metadata("design:paramtypes", [typeof (_a = typeof support_api_service_1.SupportAPIService !== "undefined" && support_api_service_1.SupportAPIService) === "function" ? _a : Object, typeof (_b = typeof toast_service_1.ToastService !== "undefined" && toast_service_1.ToastService) === "function" ? _b : Object])
], SupportComponent);
exports.SupportComponent = SupportComponent;
